import { IExpenseDocument, IExpensesPayrollData, IHierarchyDefinition } from "../models"
import AccountStore from "../stores/AccountStore"
import * as utils from "./utils"
import * as hierarchyHelper from "./hierarchyHelper"

export function getTimeDurationInHours(expense: IExpenseDocument | IExpensesPayrollData) {
    return utils.roundToTwo(expense.Amount)
}

export function getProductiveTimeInHours(expense: IExpenseDocument | IExpensesPayrollData) {
    const expensePayType = AccountStore.getCurrentAccount().PayTypes.find(i => i.Id == expense.PayTypeId)
    if (expense.TimeDurations != null && expensePayType && expensePayType.UseTowardsOvertime == true) {
        return utils.roundToTwo(expense.TimeDurations.RegularDurationInHours + expense.TimeDurations.OTDurationInHours + expense.TimeDurations.OT2DurationInHours)
    }
    return 0
}

export function getExpenseEffectTime(expense: IExpenseDocument | IExpensesPayrollData) {
    // for now, overtimeFactor and overtime2Factor are hard coded in here.
    // later we may allow payclass selection for expense. This will be a step 2 and it is a better way.
    const overtimeFactor = 1.5, overtime2Factor = 2;

    return isOTExpense(expense) ?
        expense.TimeDurations.RegularDurationInHours + expense.TimeDurations.OTDurationInHours * overtimeFactor + expense.TimeDurations.OT2DurationInHours * overtime2Factor :
        expense.Amount
}

function isOTExpense(expense: IExpenseDocument | IExpensesPayrollData) {
    const expensePayType = AccountStore.getCurrentAccount().PayTypes.find(i => i.Id == expense.PayTypeId)
    if (expense.TimeDurations != null && expensePayType && expensePayType.UseTowardsOvertime == true) {
        return expense.TimeDurations.RegularDurationInMinutes != 0 || expense.TimeDurations.OTDurationInMinutes != 0 || expense.TimeDurations.OT2DurationInMinutes != 0
    }
    else {
        return false
    }
}

export function getDisableExpenseByDefinition(hierarchyId: string, jobId: string, phaseId: string): boolean {
    if (jobId || phaseId)
        return false
    return hierarchyId ?
        hierarchyHelper.getHierarchyDefinitionByHierarchyItemId(hierarchyId).DisableExpense :
        AccountStore.getCurrentAccountSettings().DisableExpense
}